export const LOGIN_API_URL = '/Account/ValidateUser';
export const REGISTER_API_URL = '/Account/Register';
export const COUNTRY_LIST_API_URL = '/Dropdown/GetCountries';
export const FORGOT_PASSWORD_API_URL = '/Account/ForgotPassword';
export const NEW_PASSWORD_API_URL = '/Account/SetNewPassword';
export const CHANGE_PASSWORD_API_URL = '/Account/ChangePassword';
export const NOTIFICATION_API_URL = '/Notification/GetAllNotifications';
export const READ_NOTIFICATION_API_URL = '/Notification/ReadNotifications';
export const VENDOR_FILE_REJECT_API_URL = '/Vendor/SaveVendorRejectedFile';
export const VENDOR_MY_METRICS_LIST_API_URL = '/Vendor/GetMyMetrics';
export const VENDOR_PROFILE_DETAILS_API_URL = '/Vendor/GetProfileDetail';
export const VENDOR_EDIT_PROFILE_DETAILS_API_URL = '/Vendor/UpdateProfileInfo';
export const STATE_API_URL = '/Dropdown/GetStates';
export const PROOFREADER_EDITOR_API_URL = '/Proofreader/GetRecordingDetails';
export const TRANSCRIPTION_DOCUMENT_API_URL = '/Transcription/GetDocuments';
export const VENDOR_NAME_LIST_API_URL = '/Dropdown/GetOtherVendors';
export const VENDOR_PROOFREADER_COMMENT_API_URL = '/Vendor/GetProofReaderComments';
export const VENDOR_DETAIL_API_URL = '/Proofreader/VendorDetail';
export const VENDOR_RESOLVE_PROOFREADER_COMMENT_API_URL = '/Vendor/ResolveProofReaderComment';
export const PROOFREADER_EDITOR_UNCLAIM_API_URL = '/Proofreader/UnclaimFile';
export const PROOFREADER_ALL_FILE_LIST_API_URL = '/Proofreader/GetAllFileList';
export const PROOFREADER_MY_FILE_LIST_API_URL = '/Proofreader/GetMyFileList';
export const PROOFREADER_VENDOR_FILTER_LIST_API_URL = '/Dropdown/GetVendorFilterList';
export const PROOFREADER_VENDOR_LIST_API_URL = '/Proofreader/VendorList';
export const PROOFREADER_FILE_FILTER_API_URL = '/Dropdown/GetFilesFilterList';
export const GET_CGA_CLIENT_LIST_API_URL = '/Dropdown/GetCGAClientList';
export const PROOFREADER_DASHBOARD_FILE_COUNT_API_URL = '/Proofreader/GetDashboardFileCounts';
export const PROOFREADER_ROLE_EDITOR_SUBMIT_URL = '/ProofreaderSubmission/SubmitFile';
export const PROOFREADER_NEXT_TRANSCRIPT_SUBMIT_URL = '/Proofreader/GetTranscriptParagraph';
export const PROOFREADER_TRANSCRIPT_SUBMIT_URL = '/Proofreader/GetTranscript';
export const VENDOR_SUBMIT_API_URL = '/Vendor/SubmitFile';
export const PROOFREADER_SAVE_TRANSCRIPT_PARAGRAPH_FILE_URL = '/Proofreader/SaveTranscriptParagraph';
export const TRANSCRIPT_COMPLETE_PARAGRAPH_API_URL = '/Transcription/CompleteParagraph';
export const GET_ALL_SPEAKERS_API_URL = '/Transcription/GetAllSpeakers';
export const UPDATE_SPEAKERS_API_URL = '/Transcription/UpdateProjectSpeaker';
export const DELETE_SPEAKERS_API_URL = '/Transcription/DeleteProjectSpeaker';
export const ADD_SPEAKERS_API_URL = '/Transcription/AddProjectSpeaker';
export const REMOVE_UNUSED_SPEAKERS_API_URL = '/Transcription/RemoveUnusedProjectSpeaker';
export const SAVE_TRANSCRIPTION_CONFIGURATION_API_URL = '/Transcription/SaveTranscriptionConfiguration';
export const PROOFREADER_CHECK_FORCE_UNCLAIM_API_URL = '/Vendor/CheckForceUnclaim';
export const SAVE_SLATE_DATA_API_URL = '/Transcript/SaveTranscriptJsonFileInS3';
export const RESTORE_API_URL = '/Transcript/GetRestoreTranscriptJsonFile';
export const VENDOR_TRANSCRIPT_SUBMIT_URL_COPY = '/Transcript/GetTranscriptJsonFile';
export const GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_API_URL = '/Transcript/GetLegalTemplateFormFieldDetails';
export const SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_API_URL = '/Transcript/SaveOrUpdateLegalTemplateFormDetails';
export const DOWNLOAD_LEGAL_DOCUMENT_API_URL = '/Transcript/DownloadLegalDocument';
export const UPLOAD_LEGAL_DOCUMENT_API_URL = '/Transcript/UploadLeaglDocument';
export const CGA_FILES_LIST_API_URL = '/Proofreader/GetAllCGAFileList';
export const MERGE_CGA_FILE_COLLECTION_DOWNLOAD_API_URL = '/Proofreader/MergeCGAFileCollectionDownload';
export const SAVE_FILE_MERGE_STATUS_CGA_API_URL = '/Proofreader/SaveFileMargeStatusCGA';
export const GET_USER_GLOSSARY_LIST_API_URL = '/Proofreader/GetUserGlossaryList';
